
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cartoon/[slug]",
      function () {
        return require("private-next-pages/cartoon/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cartoon/[slug]"])
      });
    }
  